import type React from 'react';

import { Avatar } from '@change/ds-core-ui/Avatar';
import { Text } from '@change/ds-core-ui/Text';
import { Input, TextField } from '@change/ds-forms/TextField';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { FormState } from '../../shared/types';
import { getError } from '../../utilities/getError';

export const LoginForm: React.FC<{
	userInfo: { avatarUrl: string; displayName: string; location: string } | undefined;
	formState: FormState | undefined;
	email: string;
	setEmail: (newEmail: string) => void;
	password: string;
	setPassword: (newPassword: string) => void;
}> = ({ userInfo, formState, email, setEmail, password, setPassword }) => {
	const { translate } = useI18n();
	return (
		<div className="mb-4">
			{userInfo && (
				<div className="border-stroke-strong rounded-md border px-2" data-testid="user-info-box">
					<div className="flex h-14.5 items-center">
						<Avatar size={36} className="mr-2 shrink-0" src={userInfo.avatarUrl} alt="" />
						<div className="flex-1">
							<Text as="div" fontWeight="bold">
								{userInfo.displayName}
							</Text>
							<Text as="div" className="text-typography-weak">
								{userInfo.location}
							</Text>
						</div>
					</div>
				</div>
			)}
			{!userInfo && (
				<TextField
					validationBehavior="aria"
					type="email"
					name="email"
					label=""
					labelIsVisible={false}
					placeholder={translate('fe.components.login_or_join.email.placeholder')}
					aria-label={translate('fe.components.login_or_join.email.placeholder')}
					errorMessage={getError('email', formState)}
					isInvalid={!!getError('email', formState)}
					value={email}
					onChange={setEmail}
					input={<Input data-testid="login-modal-email" data-qa="email" />}
				/>
			)}
			<div className="mt-4">
				<TextField
					validationBehavior="aria"
					type="password"
					name="password"
					label=""
					labelIsVisible={false}
					placeholder={translate('fe.components.login_or_join.password.placeholder')}
					aria-label={translate('fe.components.login_or_join.password.placeholder')}
					errorMessage={getError('password', formState)}
					isInvalid={!!getError('password', formState)}
					value={password}
					onChange={setPassword}
					input={<Input data-testid="login-modal-password" data-qa="password" />}
				/>
			</div>
		</div>
	);
};
